import "bootstrap-daterangepicker/daterangepicker.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import * as Sentry from "@sentry/react";

import "../public/css/devarea.scss";
import { AppRouter } from "./Router.jsx";
import "./i18n";

console.log(`Environ is ${process.env.NODE_ENV}`);

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://11993d00ae6d40b59f2b92d4755f696f@store-sentry.vkplay.ru/120",
        environment: process.env.NODE_ENV,
        tracesSampleRate: 1.0,
    });
}

const root = createRoot(document.getElementById("root"));
root.render(<RouterProvider router={AppRouter} />);
